export default __webpack_public_path__ + "static/media/guidesDesktop.d7c72c9f.PNG";